import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { Company } from '../../models/company.model';
import { CardComponent } from '../card/card.component';
import { ButtonComponent } from '../button/button.component';
import { LanguageRoutingService } from '../../services/language-routing.service';

@Component({
  selector: 'app-company-card',
  standalone: true,
  imports: [CommonModule, TranslocoModule, CardComponent, ButtonComponent],
  templateUrl: './company-card.component.html',
  styleUrls: ['./company-card.component.scss'],
})
export class CompanyCardComponent {
  @Input() company!: Company;

  constructor(
    private router: Router,
    private languageRoutingService: LanguageRoutingService
  ) {}

  viewOpenPositions(): void {
    const lang = this.languageRoutingService.getCurrentLanguage();
    this.router.navigate([lang], {
      queryParams: { companyIDs: this.company.id },
    });
  }

  get positionsCountTier(): string {
    const count = this.company?.jobCount ?? 0;
    if (count >= 5) return 'tier-high';
    if (count >= 2) return 'tier-mid';
    return 'tier-low';
  }

  onButtonClick(event: Event): void {
    event.stopPropagation();
    this.viewOpenPositions();
  }
}
